'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.Link = exports.container = undefined;

var _util = require('./util');

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

var _reactRedux = require('react-redux');

var _container = require('./container');

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Simply attaches the dispatch wrapped handleClick().


var container = (0, _reactRedux.connect)(_container.mapStateToProps, _container.mapDispatchToProps);
exports.container = container;
exports.Link = _Link2.default;
exports.mapStateToProps = _container.mapStateToProps;
exports.mapDispatchToProps = _container.mapDispatchToProps;
exports.default = container(_Link2.default);